import angular from 'angular';

import CalendarEditModalComponent from './calendar-edit-modal.cmpt';
import CategoryEditModalComponentModule from '../category-edit-modal/component';

export default angular
    .module('application.component.modals.component.calendar-edit-modal', [
        CategoryEditModalComponentModule.name
    ])
    .component(CalendarEditModalComponent.selector, CalendarEditModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/calendar-edit-modal/index.js